export default __webpack_public_path__ + "static/media/rsmq.ed91026c.svg";